import React from 'react'

export const Close = ({
  width = 32,
  height = 32,
  fill,
  onClick,
  className,
}) => (
  <div
    className={`p-3 cursor-pointer bg-pink-400 rounded-full ${className}`}
    onClick={onClick}
  >
    <svg
      width={width}
      height={height}
      fill={fill ? fill : 'white'}
      viewBox="0 0 40 40"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="m41.2463203 19.2536797h-17.5v-17.50000004c0-.4834375-.3915625-.875-.875-.875h-3.5c-.4834375 0-.875.3915625-.875.875v17.50000004h-17.49999996c-.4834375 0-.875.3915625-.875.875v3.5c0 .4834375.3915625.875.875.875h17.49999996v17.5c0 .4834375.3915625.875.875.875h3.5c.4834375 0 .875-.3915625.875-.875v-17.5h17.5c.4834375 0 .875-.3915625.875-.875v-3.5c0-.4834375-.3915625-.875-.875-.875z"
        transform="matrix(.70710678 -.70710678 .70710678 .70710678 -10 20.405592)"
      />
    </svg>
  </div>
)
